import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M5.66466 3.21967C5.80532 3.07902 5.99608 3 6.19499 3H11.085C11.2839 3 11.4747 3.07902 11.6153 3.21967L20.784 12.3884C21.0769 12.6813 21.0769 13.1562 20.784 13.4491L13.4491 20.784C13.1562 21.0769 12.6813 21.0769 12.3884 20.784L3.21967 11.6153C3.07902 11.4747 3 11.2839 3 11.085V6.19499C3 5.99608 3.07902 5.80532 3.21967 5.66466L5.66466 3.21967Z',
                    fill: '#82869E',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M8.94556 11.0852C9.95831 11.0852 10.7793 10.2642 10.7793 9.25147C10.7793 8.23872 9.95831 7.41772 8.94556 7.41772C7.93281 7.41772 7.11182 8.23872 7.11182 9.25147C7.11182 10.2642 7.93281 11.0852 8.94556 11.0852Z',
                    stroke: 'white',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M12.9187 15.6693L10.7793 13.5299',
                    stroke: 'white',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M15.364 13.2242L13.2246 11.0848',
                    stroke: 'white',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const PromoFilled = React.forwardRef(IconComponent);
PromoFilled.displayName = 'PromoFilled';

export { PromoFilled };
